const initialState = {
  resolutions: [],
  lastDoc: null,
  hasMoreResolutions: true,
  isFetchingResolutions: false,
  error: null,
  singleResolution: [],
  isLoading: false,
  isLoadings: false,
  resolutionchats: [],
  singleUser: [],
};

const resolutionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_RESOLUTIONS_PENDING":
      return {
        ...state,
        isFetchingResolutions: true,
        error: null,
      };
    case "FETCH_RESOLUTIONS_SUCCESS":
      return {
        ...state,
        resolutions: action.payload.resolutions,
        lastDoc: action.payload.lastDoc,
        hasMoreResolutions: action.payload.hasMoreResolutions,
        isFetchingResolutions: false,
      };
    case "FETCH_RESOLUTIONS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        resolutions: [...state.resolutions, ...action.payload.resolutions],
        lastDoc: action.payload.lastDoc,
        hasMoreResolutions: action.payload.hasMoreResolutions,
        isFetchingResolutions: false,
      };
    case "FETCH_ESOLUTIONS_REJECTED":
      return {
        ...state,
        isFetchingResolutions: false,
        error: action.error,
      };
    case "GET_RESOLUTIONS":
      return {
        ...state,
        resolution: action.payload,
      };
    case "GET_SINGLE_RESOLUTION":
      return {
        ...state,
        singleResolution: action.payload,
      };
    case "SET_IS_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_IS_LOADINGS":
      return {
        ...state,
        isLoadings: action.payload,
      };
    case "GET_RESOLUTION_CHAT":
      return {
        ...state,
        resolutionchats: action.payload,
      };
    case "GET_SINGLE_USER":
      return {
        ...state,
        singleUser: action.payload,
      };

    default:
      return state;
  }
};
export default resolutionReducer;
